// ─────────────────────────────────────────────────────────────
// EDITABLE FAQ DATA — answers are editable and make no
// unverified claims about policies or services.
// ─────────────────────────────────────────────────────────────

import { site } from "../config/site";

export const faqCategories = [
  "Appointments",
  "Services",
  "Pricing",
  "Location",
  "Opening Hours",
  "Contact",
];

export const faqs = [
  {
    category: "Appointments",
    q: "Do I need an appointment?",
    a: "Walk-ins are welcome subject to availability, but we recommend booking ahead so we can reserve time for you. Call or WhatsApp us to plan your visit.",
  },
  {
    category: "Appointments",
    q: "How can I book an appointment?",
    a: `Call us on ${site.phoneDisplay}, message us on WhatsApp, or send an appointment request through this website. Appointment requests are subject to availability — we'll confirm your slot with you.`,
  },
  {
    category: "Services",
    q: "What services do you offer?",
    a: "Glow & Blow is a unisex salon offering hair, colour, beauty, grooming and styling services. Our service menu is being finalised for the website — contact the salon for the current list.",
  },
  {
    category: "Services",
    q: "Do you offer services for men and women?",
    a: "Yes. We are a unisex salon and welcome everyone for hair, beauty and grooming services.",
  },
  {
    category: "Services",
    q: "How long does a service take?",
    a: "It depends on the service. A haircut may take under an hour, while colour and treatment services take longer. Tell us what you're looking for when booking and we'll guide you on timing.",
  },
  {
    category: "Pricing",
    q: "How much do services cost?",
    a: "Pricing varies by service, hair length and your requirements. Please contact the salon for current pricing — we'll happily share details before you book.",
  },
  {
    category: "Opening Hours",
    q: "What are your opening hours?",
    a: `We are open ${site.hoursDays}, ${site.hoursTime}.`,
  },
  {
    category: "Location",
    q: "Where is the salon located?",
    a: `You'll find us at ${site.addressLine1}, ${site.addressLine2}. Use the Get Directions button on this site for turn-by-turn navigation.`,
  },
  {
    category: "Contact",
    q: "Can I contact the salon on WhatsApp?",
    a: `Yes — message us on WhatsApp at ${site.phoneDisplay} and we'll assist with enquiries and appointments.`,
  },
];
